import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { confirmReferralSuccess } from '../redux/modules/friends'
import { Action, H2, P } from '@foodsby/nutrient'
import { homeRoute } from '../routes/routes'
import { Link, Redirect } from 'react-router-dom'
import CollectEmailPanel from '../components/home/CollectEmailPanel'
import { pushAnalyticsEvent } from '../util/gtmUtils'
import { useQueryParam } from '../hooks/common'
import { useReferralDetails, useReferralRedemption } from '../hooks/referral'
import { normalizeReferralRedemptionErr } from '../util/errorUtils'
import { Article, SpinnerCard } from '../components/common/Layout'
import { CopyReferral } from '../components/community/Referral'
import LoginFormContainer from '../components/login/LoginFormContainer'

export const PageReferral = ({ isAuthenticated, confirmReferralSuccess }) => {
  const [showLogin, setShowLogin] = useState(false)
  const referralCode = useQueryParam('token')
  const {
    referralDetails,
    referralError,
    referralLoading,
  } = useReferralDetails(referralCode)
  const {
    redemptionResult,
    redemptionError,
    redemptionLoading,
  } = useReferralRedemption(referralCode)

  // Acknowledgement
  useEffect(() => {
    if (redemptionResult) {
      confirmReferralSuccess(redemptionResult)
    }
  }, [confirmReferralSuccess, redemptionResult])

  // Analytics
  useEffect(() => {
    if (!isAuthenticated && referralDetails) {
      pushAnalyticsEvent('Referral', 'Registration Form Shown')
    }
  }, [isAuthenticated, referralDetails])

  return (
    <Article>
      <SpinnerCard
        className="PageReferral-card"
        spinnerActive={
          referralLoading ||
          redemptionLoading ||
          (!referralDetails && !referralError && !redemptionError)
        }
      >
        {!isAuthenticated && referralDetails && (
          <div className="PageReferral-register">
            <H2 mb={1}>Way to go!</H2>
            <P mb={1}>That referral checks out.</P>
            {!showLogin ? (
              <P mb={3}>
                Already have an account?{' '}
                <Action onClick={() => setShowLogin(true)}>Log in</Action>
              </P>
            ) : (
              <P mb={3}>
                Need to create an account?{' '}
                <Action onClick={() => setShowLogin(false)}>Sign up</Action>
              </P>
            )}
            {showLogin ? (
              <LoginFormContainer path={window.location.pathname} />
            ) : (
              <CollectEmailPanel
                className=""
                entryPoint="REFERRAL"
                locationId={referralDetails?.locationId}
              />
            )}
          </div>
        )}
        {(redemptionError || referralError) && (
          <div className="PageReferral-error">
            <h5>
              {normalizeReferralRedemptionErr(redemptionError || referralError)}
            </h5>
          </div>
        )}
        {isAuthenticated && (referralError || redemptionError) && (
          <>
            <div className="row start-xs referral-copy">
              <div className="col-xs-12">
                <CopyReferral />
              </div>
            </div>
            <div className="row start-xs">
              <div className="col-xs-12">
                <Link to={homeRoute.path}>
                  <Action>View today's deliveries</Action>
                </Link>
              </div>
            </div>
          </>
        )}
        {!isAuthenticated && (referralError || redemptionError) && (
          <>
            <div className="row start-xs">
              <div className="col-xs-12">
                <Link to={homeRoute.path}>
                  <Action>
                    Login or Create an account to place your next order with
                    Foodsby
                  </Action>
                </Link>
              </div>
            </div>
          </>
        )}
        {redemptionResult && <Redirect to={homeRoute.path} />}
      </SpinnerCard>
    </Article>
  )
}

const mapStateToProps = state => {
  const { isAuthenticated, isCurrentUserLoading, currentUser } = state.user
  return {
    isAuthenticated,
    isCurrentUserLoading,
    currentUser,
  }
}

const mapDispatchToProps = { confirmReferralSuccess }

export default connect(mapStateToProps, mapDispatchToProps)(PageReferral)
